<section
  class="connections"
  aria-labelledby="microsoft-teams-title"
>
  <h2
    id="microsoft-teams-title"
    class="connections-title"
  >
    Microsoft Teams
  </h2>

  <p class="connections-description">
    To get the data correctly, please allow in application: CallRecordings.Read.All, Directory.ReadWrite.All, Place.Read.All
  </p>

  @if (isServiceDisabled()) {
    <div
      class="connections-alert connections-alert-error connections-disabled-alert"
      role="alert"
    >
      <span
        class="connections-alert-icon connections-alert-error-icon"
        aria-hidden="true"
      >×</span>
      <span>Disabled by Harmony</span>
    </div>
  }

  @if (permissionsAlertMessage(); as message) {
    <div
      class="connections-alert connections-alert-warning connections-permissions-alert"
      role="alert"
    >
      <i
        class="icon-warning connections-alert-icon connections-alert-warning-icon"
        aria-hidden="true"
      ></i>
      <span>{{ message }}</span>
    </div>
  }

  <form
    class="connections-form"
    [formRoot]="connectionForm"
  >
    <div class="connections-row">
      <label
        class="connections-label"
        for="appId"
      >App ID:</label>
      <mat-form-field
        class="connections-input input-main"
        appearance="outline"
      >
        <input
          id="appId"
          type="text"
          [formField]="connectionForm.appId"
          autocomplete="off"
          matInput
          placeholder="Enter App ID"
        />
      </mat-form-field>
    </div>

    <div class="connections-row">
      <label
        class="connections-label"
        for="directoryId"
      >Directory ID:</label>
      <mat-form-field
        class="connections-input input-main"
        appearance="outline"
      >
        <input
          id="directoryId"
          type="text"
          [formField]="connectionForm.directoryId"
          autocomplete="off"
          matInput
          placeholder="Enter Directory ID"
        />
      </mat-form-field>
    </div>

    <div class="connections-row">
      <label
        class="connections-label"
        for="secretValue"
      >Secret Value:</label>
      <mat-form-field
        class="connections-input input-main"
        appearance="outline"
      >
        <input
          id="secretValue"
          type="text"
          [formField]="connectionForm.secretValue"
          autocomplete="off"
          matInput
          placeholder="Enter Secret Value"
        />
      </mat-form-field>
    </div>

    <div class="connections-row connections-action-row">
      <span class="connections-label">Connect Microsoft Teams</span>
      @if (!isConnected()) {
        <button
          type="submit"
          class="btn-black btn-medium connections-button"
          [disabled]="isConnectDisabled()"
        >
          Connect & Save
        </button>
      } @else {
        <button
          type="button"
          class="btn-red btn-medium connections-button connections-disconnect-button"
          (click)="disconnect()"
          [disabled]="isDisconnecting()"
        >
          Disconnect
        </button>
      }
    </div>
  </form>
</section>
